import createVueComponent from '../createVueComponent';

const ArrowDown = createVueComponent('ArrowDownIcon', [
  ['path', { d: 'M12 5v14', key: 's699le' }],
  ['path', { d: 'm19 12-7 7-7-7', key: '1idqje' }],
]);

export default ArrowDown;
